import React from "react";
import { NavLink, useLocation } from "react-router-dom";

const QuoteTab = ({ tabs }) => {
  const { pathname } = useLocation();

  return (
    <nav className="app-container">
      <ul className="app-tabs">
        {tabs.map((tab) => (
          <li
            key={tab.id}
            className={`app-tab-item ${
              pathname.includes(tab.link) ? "active" : ""
            }`}
          >
            <NavLink className="app-tab-item-link" to={tab.link} end>
              {tab.title}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default QuoteTab;
